module.exports = __webpack_public_path__ + "img/file-icon_docx.fe0871c5.svg";